// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContactStyles } from "@steiner/App/Widgets/Footer/FooterContact";
import { css } from "styled-components";

footerContactStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

footerContactStyles.title = {
    variant: "h4",
    as: "p",
    color: "common.white",
};

footerContactStyles.linksWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

footerContactStyles.link = {
    color: "common.white",
    typographyProps: {
        size: 12,
        css: css`
            line-height: 15px;
        `,
    },
    css: css`
        align-self: baseline;
    `,
};
